import React, { useState, useEffect } from 'react';
import { Card } from "@mui/material";
import { Divider, Box, Grid } from "@mui/material";
import useFetch from "../../utils/useFetch";
import BaseURL from '../../utils/base-uri.json';
import GetfVDateFormate from '../../utils/Genaricfunctions';
import { getOrgType } from '../../utils/Token';


export default function UserOrganizationContext({
    Secid,
    SubId,
    SectionType,
    SubSectionTypeCondition,
    pqStartDate,
    pqClientVendorRef
}) {
    const params = new URLSearchParams(window.location.search);
    const PQID = params?.get("pqid");
    const [response, setResponse] = useState([]);

    const {
        data: resp,
        loading,
        error,
    } = useFetch(BaseURL.baseUrl + "Prequalification/SectionOrSubSectionDetails?pqId=" + PQID + "&sectionId=" + Secid + "&subSectionTypeCondition=" + SubSectionTypeCondition + "&sectionType=" + SectionType + "&subSectionId=" + SubId,); // TODO: remove localhost arg

    useEffect(() => {
        if (resp?.data) {
            setResponse(resp.data?.userInputData);
        }
    }, [resp]);
    return (
        <>
            {SubSectionTypeCondition == "UserOrganization" ?
                <Box className="mt-3 " sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ xs: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            {/* General infomation */}
                            <Card sx={{ padding: "20px", height: "205px" }}>
                                <h5
                                    className="card-title "
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        marginBottom: 10,
                                        color: "#667085",
                                    }}
                                >
                                    General information
                                </h5>
                                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }}
                                >
                                    <span sx={{ marginRight: "auto" }} id="Name">Legal Name of Business:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {response?.Name}</span>
                                </h5>
                                <h5
                                    className="card-subtitle"
                                    style={{
                                        fontSize: "15px",
                                        color: "#667085",
                                        marginBottom: 5,

                                        fontWeight: 400,
                                    }}
                                >
                                    <span style={{ marginRight: "auto" }}>Tax ID: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {response?.TaxID}</span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} hidden={getOrgType() != "Admin"}
                                >
                                    <span sx={{ marginRight: "auto" }}>Vendor ID: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{pqClientVendorRef}</span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} hidden={getOrgType() != "Admin"}
                                >
                                    <span sx={{ marginRight: "auto" }} >Started: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{pqStartDate ? GetfVDateFormate(null, null, pqStartDate) : ""} </span>
                                </h5>
                            </Card>
                        </Grid>
                        {/* Address */}
                        <Grid item xs={12} sm={4} md={4}>
                            <Card sx={{ padding: "20px", height: "205px" }}>
                                <h5
                                    className="card-title "
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        marginBottom: 10,
                                        color: "#667085",
                                    }}
                                >
                                    Address
                                </h5>
                                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                                <h5
                                    className="card-subtitle"
                                    style={{
                                        fontSize: "15px",
                                        color: "#667085",
                                        marginBottom: 5,
                                        marginTop: 10,
                                        fontWeight: 400,
                                    }}
                                >
                                    <span style={{ marginRight: "auto", color: "#101828" }}>
                                        {response.Country}
                                    </span>
                                </h5>

                                <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 5, fontWeight: 400, }}>
                                    <span sx={{ marginRight: "auto", color: "#101828" }}> {response?.Address1} , {response?.Address2}</span>
                                </h5>
                                <h5 style={{ fontSize: "15px", color: "#101828", fontWeight: 400, marginBottom: 5 }}>
                                    <span sx={{ marginRight: "auto", color: "#101828" }}> {response.City},{response?.State} </span>
                                </h5>
                                <h5 style={{ fontSize: "15px", color: "#101828", fontWeight: 400, marginBottom: 5 }}>
                                    <span sx={{ marginRight: "auto", color: "#101828" }}> {response?.Zip}</span>
                                </h5>

                            </Card>
                        </Grid>

                        {/* Contact Information */}
                        <Grid item xs={12} sm={4} md={4}>
                            <Card sx={{ padding: "20px", height: "205px" }}>
                                <h5
                                    className="card-title "
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        marginBottom: 10,
                                        color: "#667085",
                                    }}
                                >
                                    Contact Information
                                </h5>
                                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                                <h5 style={{ fontSize: "15px", color: "#667085", fontWeight: 500, marginBottom: 5 }}>
                                    <span sx={{ marginRight: "auto" }}>Principal Officer Name:</span><span style={{ fontSize: "15px", marginBottom: 5, color: "#101828" }}> {response?.PrincipalCompanyOfficerName}</span>
                                </h5>
                                <h5
                                    className="card-subtitle"
                                    style={{
                                        fontSize: "15px",
                                        color: "#667085",
                                        fontWeight: 400,
                                        marginBottom: 5,

                                    }}
                                >
                                    <span style={{ marginRight: "auto" }}>Phone:</span><span style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5 }}> {response?.PhoneNumber}</span>
                                </h5>
                                <h5 style={{ fontSize: "15px", color: "#667085", fontWeight: 500, marginBottom: 5 }}>
                                    <span sx={{ marginRight: "auto" }}>Fax:</span><span style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5 }}> {response?.FaxNumber}</span>
                                </h5>
                                <h5 style={{ fontSize: "15px", color: "#667085", fontWeight: 500, marginBottom: 5 }}>
                                    <span sx={{ marginRight: "auto" }}>Website :</span><span style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5, cursor: "pointer" }}><a style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5, cursor: "pointer", textDecoration: "none" }} href={response?.WebsiteURL}> {response?.WebsiteURL}</a></span>
                                </h5>

                            </Card>
                        </Grid>
                    </Grid>
                </Box>

                : <Box className="mt-3 " sx={{ flexGrow: 1 }}>
                    <Grid container spacing={{ xs: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            {/* General infomation */}
                            <Card sx={{ padding: "20px", height: "auto" }}>
                                <h5
                                    className="card-title "
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        marginBottom: 10,
                                        color: "#667085",
                                    }}
                                >
                                    Vendor Information
                                </h5>
                                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }}
                                >
                                    <span sx={{ marginRight: "auto" }} id="Name">Legal Name of Business:</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {response?.Name}</span>
                                </h5>
                                <h5
                                    className="card-subtitle"
                                    style={{
                                        fontSize: "15px",
                                        color: "#667085",
                                        marginBottom: 5,

                                        fontWeight: 400,
                                    }}
                                >
                                    <span style={{ marginRight: "auto" }}>First Name: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}> {response?.FirstName}</span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} 
                                >
                                    <span sx={{ marginRight: "auto" }}>Last Name: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{response?.LastName}</span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} 
                                >
                                    <span sx={{ marginRight: "auto" }} >Title: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{response?.ContactTitle} </span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} 
                                >
                                    <span sx={{ marginRight: "auto" }} >Phone Number: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{response?.PhoneNumber} </span>
                                </h5>
                                <h5
                                    style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }} 
                                >
                                    <span sx={{ marginRight: "auto" }} >Email: </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{response?.Email} </span>
                                </h5>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            }
        </>
    )
}